import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { BehaviorSubject } from 'rxjs';
import { AlertController, NavController } from '@ionic/angular';
@Component({
  selector: 'app-instances',
  templateUrl: './instance.page.html',
  styleUrls: ['./instance.page.scss'],
})
export class InstancePage implements OnInit {
  private incomingSearchText$ = new BehaviorSubject('');
  breadcrumbList = [
    {
      label: 'Instance',
      url: '/baseapp/instances'
    },
    {
      label: 'List',
      url: '/baseapp/instances'
    }
  ];
  userIp: any;
  resultdata: any =[];
  userDisplayedColumns: string[] = ['instance','ip_address','is_default','hostname', 'ssh_port', 'action'];//Instance,IP Address,Is Default?,hostname
  instance: any;
  id: any;
  search = "";
  Instances:any = [];
  bubbleshow: boolean = false;
  constructor(private formBuilder: UntypedFormBuilder,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    private route: ActivatedRoute,
    public alertController:AlertController,
    public helperService: HelperService, 
    private nav: NavController) { }

  ngOnInit() {
    this.getInstanceDetails();
    // this.getUserIp();
  }

  
  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      role_id: await this.storage.get("role_id"),
    }
    return data;
  }



  getUserIp(){
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
    })
  }
  searchStringMethod(message: string) {
		this.incomingSearchText$.next(message);
	}

  getSearchOnChange(e){
    this.searchStringMethod(e);
  }

  clearSearch(){
    this.search = "";
    this.searchStringMethod(this.search);
  }

  editInstance(id){
    this.router.navigate(['baseapp/instances/update', id])
  }

  getInstanceDetails(){
    this.helperService.loader();
    this.getStorage().then((res)=>{
      if(res.role_id != 1){
        this.nav.navigateRoot(['baseapp/notauthorized']);
        return
      }
      this.backendService.GetAPICall('getInstance', res.token).subscribe(
        (data) => {
          this.helperService.closeLoader();
          // this.Instances.push(data);
          this.resultdata = data;//this.Instances;          
        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    });
  }
  viewMore(id:any){
    this.router.navigate(['baseapp/instances/details', id])
  }
  confirmDelete(userId) {
    const header = 'Confirm!';
    const msg = "Are you sure you want to delete?"
    this.confirmDeleteAlert(header, msg, userId,)
  }

  deleteInstance(id){
    this.helperService.loader();
    this.getStorage().then((res)=>{
      let url = `/api/integrationBridge/deleteInstance/${id}`;
      this.backendService.DeleteAPICall(url, res.token).subscribe(
        (res) => {
          this.helperService.closeLoader();
          this.helperService.presentToast(res.msg, 2000);
          this.getInstanceDetails();
        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }
  async confirmDeleteAlert(header, msg, userId) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'CANCEL',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          }
        }, {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            this.deleteInstance(userId)
          }
        }
      ]
    });
    await alert.present();
  }
  closebubblecross(){
    this.bubbleshow = false;
  }

  closebubble(){
    this.bubbleshow = false;
  }
}
